import { useEffect, useMemo, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';

export function useIsSortByInView() {
  const [searchBarHeight, setSearchBarHeight] = useState(0);
  const animationFrameRef = useRef(0);

  useEffect(() => {
    const searchBar = document.getElementById('search-wrapper');

    if (!searchBar) return;

    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (animationFrameRef.current) {
          cancelAnimationFrame(animationFrameRef.current);
        }

        animationFrameRef.current = requestAnimationFrame(() => {
          setSearchBarHeight(entry.contentRect.height);
        });
      }
    });

    resizeObserver.observe(searchBar);

    setSearchBarHeight(searchBar.getBoundingClientRect().height);

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
      resizeObserver.disconnect();
    };
  }, []);

  // Calculate rootMargin based on search bar height
  // Absolute top value is already accounted for in rect.height
  const rootMargin = useMemo(() => {
    const margin = searchBarHeight > 0 ? -(searchBarHeight + 8) : -80;

    return `${margin}px 0px 0px 0px`;
  }, [searchBarHeight]);

  const [ref, inView] = useInView({
    threshold: 0,
    rootMargin
  });

  return [ref, inView] as const;
}
